import { useFeatureFlag } from '@/store/slices/api/featureFlagsApiSlice';

export const useNavigationV2FeatureFlag = () => {
  const isNavigationV2Enabled = useFeatureFlag('navigation_v2');

  return {
    isNavigationV2Enabled
  };
};
